import React from 'react';
import { Card, Placeholder, Spinner } from 'react-bootstrap';

const DEFAULT_ROWS = 10;

export function ModashSkeleton({ rows = DEFAULT_ROWS }: { rows?: number }) {
    return (
        <>
            <span className="d-inline-flex align-items-center ml-1">
                <Spinner animation="border" size="sm" role="status" />
                <span className="ml-2">Fetching Modash data</span>
            </span>

            <Card className="mb-4 p-4 mt-3" aria-busy="true">
                <div className="row text-center">
                    {[0, 1, 2].map(i => (
                        <div key={i} className="col-md-4 mb-3 mb-md-0">
                            <Placeholder as="div" animation="glow">
                                <Placeholder xs={5} size="sm" className="skeleton d-block mx-auto mb-3" />
                                <Placeholder xs={6} className="skeleton skeleton-stat d-block mx-auto" />
                            </Placeholder>
                        </div>
                    ))}
                </div>
            </Card>

            <Card className="mb-4 p-4">
                <Placeholder as="h5" animation="glow" className="mb-3">
                    <Placeholder className="skeleton" xs={3} />
                </Placeholder>
                <div className="list-group">
                    {Array.from({ length: rows }).map((_, i) => (
                        <div key={i} className="list-group-item d-flex justify-content-between align-items-center">
                            <Placeholder as="span" animation="glow" className="w-50">
                                <Placeholder className="skeleton" xs={8} />
                            </Placeholder>
                            <Placeholder as="span" animation="glow" className="w-25 text-end">
                                <Placeholder className="skeleton" xs={4} />
                            </Placeholder>
                        </div>
                    ))}
                </div>
            </Card>
        </>
    );
}
